/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const featureKeyEnum = {
  "agec-compliance": "agec-compliance",
  "eco-modulations": "eco-modulations",
} as const

export type FeatureKeyEnumKey =
  (typeof featureKeyEnum)[keyof typeof featureKeyEnum]

/**
 * @description Feature key to manage access for
 */
export type FeatureKey = FeatureKeyEnumKey
